var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgApprovedNumbers(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_578",
    "data-name": "Group 578",
    transform: "translate(-0.186 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_9",
    "data-name": "Ellipse 9",
    transform: "translate(0.186 0)",
    fill: "none",
    stroke: "#00cfb7",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32.5,
    cy: 32.5,
    r: 32.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32.5,
    cy: 32.5,
    r: 31.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-user-check",
    "data-name": "Icon awesome-user-check",
    d: "M12.585,14.383A7.191,7.191,0,1,0,5.394,7.191,7.191,7.191,0,0,0,12.585,14.383Zm5.034,1.8h-.938a9.78,9.78,0,0,1-8.191,0H7.551A7.553,7.553,0,0,0,0,23.731v2.337a2.7,2.7,0,0,0,2.7,2.7H22.473a2.7,2.7,0,0,0,2.7-2.7V23.731A7.553,7.553,0,0,0,17.619,16.181ZM35.766,8.967,34.2,7.388a.666.666,0,0,0-.944-.006l-5.888,5.843-2.556-2.573a.666.666,0,0,0-.944-.006l-1.579,1.567a.666.666,0,0,0-.006.944l4.59,4.624a.666.666,0,0,0,.944.006L35.76,9.911a.671.671,0,0,0,.006-.944Z",
    transform: "translate(14.32 18.061)",
    fill: "#757575"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApprovedNumbers);
export default __webpack_public_path__ + "static/media/approvedNumbers.01e6664c4f315060b1c7e9483d868e09.svg";
export { ForwardRef as ReactComponent };